import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { getCommandsLivree } from '@/api/commandes.api'
import { APP_NAME, validateCommandsPageSearchParams } from '@/lib/utils'
import CommandsLivres from '@/features/commands/components/extensions/commands-livres'

export const Route = createFileRoute('/_authenticated/commands-livres/')({
  component: () => {
    const { t } = useTranslation()
    return (
      <CommandsLivres
        queryExtension={{
          title: t('sidebar.commandes-livrees'),
          querykey: 'livree',
          queryFn: getCommandsLivree,
        }}
      />
    )
  },
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Commandes livrées`,
      },
    ],
  }),
  validateSearch: validateCommandsPageSearchParams,
})
